import { useApiClient } from './useApiClient'
import {
  AuditSearchRequest,
  AuditSearchOption,
  PagedResult,
  AuditEventSearchResult,
  IAuditEventData,
} from 'api'

export const useAuditApi = () => {
  const apiClient = useApiClient()

  const searchAuditEvents = (request: AuditSearchRequest) => {
    return apiClient.get<PagedResult<AuditEventSearchResult>>(
      'api/audit/events/search',
      {
        params: request,
        withCredentials: true,
      },
    )
  }

  const getCustomerAgencySearchOptions = () => {
    return apiClient.get<AuditSearchOption[]>(
      'api/audit/events/search/options/customerAgencies',
      {
        withCredentials: true,
      },
    )
  }

  const getLicensedAgencySearchOptions = (customerAgencyId: string) => {
    return apiClient.get<AuditSearchOption[]>(
      'api/audit/events/search/options/licensedAgencies',
      {
        params: {
          customerAgencyId: customerAgencyId,
        },
        withCredentials: true,
      },
    )
  }

  const getLicensedUserSearchOptions = (
    customerAgencyId: string,
    licensedAgencyId: string,
  ) => {
    return apiClient.get<AuditSearchOption[]>(
      'api/audit/events/search/options/licensedUsers',
      {
        params: {
          customerAgencyId: customerAgencyId,
          licensedAgencyId: licensedAgencyId,
        },
        withCredentials: true,
      },
    )
  }

  const getSupportUserSearchOptions = () => {
    return apiClient.get<AuditSearchOption[]>(
      'api/audit/events/search/options/supportUsers',
      {
        withCredentials: true,
      },
    )
  }

  const getEventTypeSearchOptions = () => {
    return apiClient.get<AuditSearchOption[]>(
      'api/audit/events/search/options/eventTypes',
      {
        withCredentials: true,
      },
    )
  }

  const getAuditEventData = (eventId: number) => {
    return apiClient.get<IAuditEventData>(`api/audit/events/${eventId}`, {
      withCredentials: true,
    })
  }

  const recordUserPageViewStarted = (
    title: string,
    url: string,
    timestamp: Date,
    isSupportPage: boolean
  ) => {
    return apiClient.post<number>('api/audit/events/user-page-view-started', {
      title: title,
      url: url,
      timestamp: timestamp,
      isSupportPage: isSupportPage
    })
  }

  const recordUserPageViewCompleted = (eventId: number, timestamp: Date) => {
    return apiClient.post('api/audit/events/user-page-view-completed', {
      eventId: eventId,
      timestamp: timestamp,
    })
  }

  return {
    searchAuditEvents,
    getCustomerAgencySearchOptions,
    getLicensedAgencySearchOptions,
    getLicensedUserSearchOptions,
    getSupportUserSearchOptions,
    getEventTypeSearchOptions,
    getAuditEventData,
    recordUserPageViewStarted,
    recordUserPageViewCompleted,
  }
}
